module.exports = __webpack_public_path__ + "static/cyclica-logo-4679d7060acb284f237e762b9b576d30.png";